import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export const AudioVisualizer = ({ className }: { className?: string }) => {
  const [bars, setBars] = useState<number[]>([]);

  useEffect(() => {
    // Generate random initial heights
    setBars(Array.from({ length: 24 }, () => Math.random() * 100));

    const interval = setInterval(() => {
      setBars(prev => prev.map(() => Math.max(10, Math.random() * 100)));
    }, 150);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={cn("flex items-center justify-center gap-1 h-16", className)}>
      {bars.map((height, i) => (
        <div
          key={i}
          className="w-1.5 bg-primary rounded-full transition-all duration-150 ease-in-out opacity-80"
          style={{ 
            height: `${height}%`,
            opacity: 0.3 + (height / 200) // Taller bars are more opaque
          }}
        />
      ))}
    </div>
  );
};
